module.exports = __webpack_public_path__ + "img/plan-logo.ad1f1156.png";